var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLhMilitaryActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2954 33.5366L19.5911 33.656V23.7424L35.2954 23.6227L51 10.5187L46.4089 8L30.7043 21.104L15 21.2237V31.1376L19.3335 33.5147L15 33.5478V43.4616L19.3335 45.839L15 45.8718V55.7857L19.5911 58.3044V48.3906L35.2954 48.2711L51 35.1671L49.2572 34.2109L35.2954 45.8606L19.5911 45.9801V36.0665L35.2954 35.9468L51 22.8428L49.2572 21.8869L35.2954 33.5366Z",
    fill: "#10260F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5911 48.3906V58.3045L35.2954 58.1847L51 45.0807V35.1671L35.2954 48.2711L19.5911 48.3906Z",
    fill: "#4AAC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5911 36.0665V45.9801L35.2954 45.8606L51 32.7566V22.8428L35.2954 35.9468L19.5911 36.0665Z",
    fill: "#4AAC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2954 23.6227L19.5911 23.7425V33.656L35.2954 33.5366L51 20.4326V10.5187L35.2954 23.6227Z",
    fill: "#4AAC00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLhMilitaryActive);
export default __webpack_public_path__ + "static/media/LHMilitary-active.456525ecd602326345db816a2e02fc91.svg";
export { ForwardRef as ReactComponent };